import React, {useCallback, useEffect} from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Box from "../../../../../../ui/Box";
import Breadcrumbs from "./../../../../../../ui/Breadcrumbs";
import Tabs from "../../../../../../ui/Tabs";
import { makeStyles } from "@material-ui/core/styles";
import TopBar from "./components/TopBar";
import Progress from "../../../../../../ui/Progress";
import { useMediaQuery } from 'react-responsive';
import ProgramInfoDrawer from "../../components/ProgramInfoDrawer";
import ProgramMainInfoView from "./components/ProgramMainInfoView";
import ProgramDescriptionEdit from "./components/ProgramDescriptionEdit";
import ProgramAnounceEdit from "./components/ProgramAnounceEdit";
import { getFullProgram } from "../../store/actions";
import {updateProgram} from "../../store/send";
import {deleteProgram} from "../../store/deleteactions";
import DeleteConfirmationModal from "../../../../../../ui/DeleteConfirmationModal";
import api from "../../api/programs";
import {createError, logSuccess} from "../../store/message";
import {logError} from "../../../../../../ui/Notify";

const useStyles = makeStyles(() => ({
  mainRoot: {
    display: "flex",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  topBar: {
    marginBottom: 10
  }
}));

const items = [
  { label: "Управление ООП", link: "#" },
  { label: "Ресурсы", link: "/work/app/manage/resources" },
  { label: "Образовательные программы и модули", link: "/work/app/manage/resources/programs" },
  { label: "Мои программы", link: "/work/app/manage/resources/programs/my-programs" }
];

const tabitems = [
  {number:0, caption: "Основные сведения"},
  {number:1, caption: "Анонс (для каталога)"},
  {number:2, caption: "Описание (для каталога)"}
];

const initialState = {
  editableProgramData: null,
  editableProgramAnnounce: null,
  editableProgramDescription: null,
  isEdited: false,
  isAnnounceEdited: false,
  isDescriptionEdited: false
};

const ProgramView = ({
                       getFullProgram,
                       programFullInfo,
                       /*getProgramHtmlDescription,
                       programHtmlDescription,
                       getProgramHtmlAnounce,
                       programHtmlAnounce,*/
                       match,
                       history,
                       isUpdatingProgram,
                       updateProgram,
                        updatedProgram,
                       deleteProgram,
                       isDeletingProgram
                     }) => {
  const { id } = match.params;
  const classes = useStyles();
  const [isEditable, setEditable] = React.useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = React.useState(false);
  const [state, setStateObject] = React.useState(initialState);

  const returnBack = () => history.push("/work/app/manage/resources/programs/my-programs");
  const isLarge = useMediaQuery({ minWidth: 1024 });
  const isSmall = useMediaQuery({ maxWidth: 774 });

  useEffect(() => {
    getFullProgram(id);
  }, [id]);

  useEffect(() => {
    if (programFullInfo) {
      setStateObject({
        ...state,
        editableProgramData:  programFullInfo.data,
        editableProgramAnnounce: programFullInfo.htmlAnnounce,
        editableProgramDescription: programFullInfo.htmlDescription
      });
    }
  }, [programFullInfo]);

  const UpdateProgramData = () => {
    const saveData = {
      main: state.isEdited ? state.editableProgramData : programFullInfo.data,
      htmlAnnounce: state.isAnnounceEdited ? state.editableProgramAnnounce : programFullInfo.htmlAnnounce,
      htmlDescription: state.isDescriptionEdited ? state.editableProgramDescription : programFullInfo.htmlDescription
    };

    setStateObject({
      ...state,
      isEdited:  false,
      isAnnounceEdited: false,
      isDescriptionEdited: false
    });
    updateProgram(id, saveData);
  }

  useEffect(() => {
    if (updatedProgram && updatedProgram.success) {
      console.log('updated');
      //getFullProgram(id);
    }
  });

  const sendToCatalog = useCallback(() => {
    try {
      return api.sendProgramToCatalog(id).then(response => {
        if (response.status === 200) {
          logSuccess("Программа отправлена в каталог");
        } else {
          logError("Не удалось отправить программу в каталог");
        }
      }, () => {
        logError("Не удалось отправить программу в каталог");
      }).catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
        } else {
          logError(err);
        }
      });
    } catch (e) {
      logError("Не удалось отправить программу в каталог");
      console.log(e);
    }
  }, []);

  return(
    <div>
      <DeleteConfirmationModal
        modalText="Удалить программу?"
        open={deleteModalOpen}
        onConfirm={() => {
          deleteProgram(id);
          returnBack();
        }}
        handleClose={() => setDeleteModalOpen(false)}
      />
      <Breadcrumbs items={items} />
      {programFullInfo ? (
        <div className={classes.mainRoot}>
          <div className={classes.pageRoot}>
            <div className={classes.topBar}>
              <TopBar
                reload={() => getFullProgram(id)}
                returnBack={returnBack}
                disabled={false}
                isUpdating={isUpdatingProgram}
                update={UpdateProgramData}
                onDelete={() => setDeleteModalOpen(true)}
                isDeleting={isDeletingProgram}
                editmode={isEditable}
                setEditMode={()=>setEditable(true)}
                setViewMode={()=>setEditable(false)}
                sendToCatalog={sendToCatalog}
              />
            </div>
            <Tabs orientation={isSmall ? "horizontal" : "vertical"} items={tabitems}>
              <Box noMargin>
                {/*<Alert style={{marginBottom: "16px"}} severity="info">
                  Редактирование основных параметров возможно только через конструктор программ.
                  В данном разделе вы можете изменить только параметры публикации в каталоге.
                </Alert>*/}
                <ProgramMainInfoView disabled={!isEditable}
                                     programId={id}
                                     programInfo={programFullInfo.info}
                                     programData={programFullInfo.data}
                                     programFile={programFullInfo.programFile}
                                     certificateFile={programFullInfo.certificateFile}
                                     onFormChange={formState => {
                                       setStateObject({
                                         ...state,
                                         editableProgramData: formState,
                                         isEdited: true
                                       });
                                     }}/>
              </Box>
              <Box noMargin>
                {<ProgramAnounceEdit disabled={false}
                                     programId={id}
                                     isEdited={state.isAnnounceEdited}
                                     programHtmlAnounce={state.editableProgramAnnounce}
                                     onFormChange={data => {
                                       setStateObject({
                                         ...state,
                                         editableProgramAnnounce: data,
                                         isAnnounceEdited: true
                                       });
                                     }}/>}
              </Box>
              <Box noMargin>
                {<ProgramDescriptionEdit disabled={false}
                                         programId={id}
                                         isEdited={state.isDescriptionEdited}
                                         programHtmlDescription={state.editableProgramDescription}
                                         onFormChange={data => {
                                           setStateObject({
                                             ...state,
                                             editableProgramDescription: data,
                                             isDescriptionEdited: true
                                           });
                                         }}/>}
              </Box>
            </Tabs>
          </div>
          {isLarge &&
          <ProgramInfoDrawer programId={id} open hideLink />}
        </div>
      ) : (
        <Progress />
      )}
    </div>
  );
}

const mapStateToProps = state => ({
  programFullInfo: state.programs.programFullInfo,
  isUpdatingProgram: state.programs.isUpdatingProgram,
  updatedProgram: state.programs.updatedProgram,
  //programHtmlAnounce: state.programs.programHtmlAnounce,
  //programHtmlDescription: state.programs.programHtmlDescription,
  isDeletingProgram: state.programs.isDeletingProgram
});

const mapDispatchToProps = dispatch => ({
  getFullProgram: id => dispatch(getFullProgram(id)),
  //getProgramHtmlAnounce: (id) => dispatch(getProgramHtmlAnounce(id)),
  //getProgramHtmlDescription: (id) => dispatch(getProgramHtmlDescription(id)),
  updateProgram: (id, data) => dispatch(updateProgram(id, data)),
  deleteProgram: (id) => dispatch(deleteProgram(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProgramView));
